import { dataAlignTop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAlignTop = /*#__PURE__*/createIcon(dataAlignTop)
export default IconAlignTop
